module.exports = __webpack_public_path__ + "static/media/22-1.fcf49839.mp3";